module.exports = __webpack_public_path__ + "img/HelpNull.1489caa3.svg";